import React, { useEffect } from 'react';
import { createRoot } from 'react-dom/client';

import 'highlight.js/styles/shades-of-purple.css';
import './style.css';

import App from './App';

const DISABLE_FRACTAL_CANVAS_INIT = false;

const VIZ_POLL_INTERVAL_MS = 200;
const RENDER_EVENT = new CustomEvent('render');

function renderVisibleFractalCanvases() {
  const viewportHeight = window.innerHeight;
  const canvases = document.getElementsByTagName('canvas');
  [...canvases].forEach((canvas) => {
    const rect = canvas.getBoundingClientRect();
    if (rect.bottom < 0 || rect.top > viewportHeight) {
      // canvas is not visible
    } else {
      // canvas is visible
      canvas.dispatchEvent(RENDER_EVENT);
    }
  });
}

function renderVisibleFractalCanvasesForever() {
  renderVisibleFractalCanvases();
  setTimeout(() => {
    renderVisibleFractalCanvasesForever();
  }, VIZ_POLL_INTERVAL_MS);
}

// Reveal app after first paint (runs after React commit + style injection from this bundle)
function RevealAfterPaint({ children }) {
  useEffect(() => {
    const mount = document.getElementById('react-mount');
    if (!mount) return;
    const show = () => { mount.style.visibility = 'visible'; };
    requestAnimationFrame(() => requestAnimationFrame(show));
  }, []);
  return children;
}

// entry point — block on fonts loading to isolate layout shift (then render)
const container = document.getElementById('react-mount');
(async function runApp() {
  await document.fonts.ready;
  createRoot(container).render(
    <React.StrictMode>
      <RevealAfterPaint>
        <App />
      </RevealAfterPaint>
    </React.StrictMode>
  );
  if (!DISABLE_FRACTAL_CANVAS_INIT) {
    renderVisibleFractalCanvasesForever();
  }
})();
